import { ITransfer } from './transfer-form';

type Receipt = ITransfer['transfer_receipts'][number];

// The folio shown/copied for a transfer receipt: an expense's external code, or
// — for a sale — its invoice code, falling back to its order code. Returns ''
// when the receipt has no linked document yet.
export function receiptFolio(receipt?: Receipt | null): string {
    if (!receipt) return '';

    const expenseCode = receipt.expense?.external_code;
    if (expenseCode) return String(expenseCode);

    const sale = receipt.order_sale;
    if (sale) {
        const code = sale.invoice_code || sale.order_code;
        if (code) return String(code);
    }

    return '';
}
